<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-card class="elevation-12">
        <v-card-title>
          Пост-отделения без родителя
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-dialog v-model="createPostIndexDialog" persistent max-width="550px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="mr-6"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
              >
                Создать пост-отделение
              </v-btn>
            </template>
            <CreatePostIndex @cancel="onCreatePostIndexCanceled" ref="createPostIndex"/>
          </v-dialog>
        </v-card-actions>
        <v-card-text>
          <v-data-table
              :items="rootPostIndexes"
              :headers="headers"
              :search="rootSearch"
              :custom-filter="rootFilter"
              :dense="true"
              :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100 ] }"
              :hide-default-header="true"
          >
            <template v-slot:top>
              <v-text-field
                  v-model="rootSearch"
                  label="Поиск"
                  class="mx-4"
              ></v-text-field>
            </template>

            <template v-slot:item.post="scope">
              <v-btn
                  :color="selectedPostIndexWithChilds && selectedPostIndexWithChilds.id === scope.item.id ? 'info' : 'secondary'"
                  block @click="onRootPostIndexClicked(scope.item)">
                {{ scope.item.postCode }} | {{ scope.item.name }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card class="elevation-12" v-if="selectedPostIndexWithChilds">
        <v-card-title>
          Настройки выбранного отделения
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="postCode"
                        @change="setPostCode"
                        label="Код пост-отделения"/>

          <v-text-field v-model="name"
                        @change="setName"
                        label="Имя пост-отделения"
                        :counter="200"
          />

          <v-select v-model="postRegion"
                    @change="setRegion"
                    :items="$store.getters.appLogin.regions"
                    :item-text="item => item.name"
                    :item-value="item => item"
                    label="Область"
          />

          <v-select v-model="postArea"
                    @change="setArea"
                    :disabled="!postRegion"
                    :items="getAreas()"
                    :item-text="item => item.name"
                    :item-value="item => item"
                    label="Район"
          />
          <v-checkbox
              @change="setActive"
              v-model="isActive"
              color="primary"
              :label="`Активный`"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions v-if="allowSelectedPostIndexMove">
          <v-spacer/>
          <v-btn color="primary" @click="onSaveButtonClicked">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <v-dialog v-model="moveDialog" max-width="500px">
      <v-card>
        <v-card-title>Выберите к какому отделению перекинуть</v-card-title>
        <v-card-text>
          <v-autocomplete v-model="moveForm.parent"
                          :items="rootPostIndexesWithOutSelected"
                          label="Родительское отделение"
                          :dense="true"
                          :item-value="item => item.id"
                          :item-text="item => `${item.postCode} | ${item.name}`"
                          :error-messages="moveFormParentErrors"
          />
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn
              color="blue darken-1"
              text
              @click="moveDialog = false"
          >
            Закрыть
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="onMoveButtonClicked"
          >
            Перекинуть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isSuccessPostIndexChanged"
                :timeout="5000"
                :top="true"
                color="success"
    >
      Данные пост отделения успешно обновлены
    </v-snackbar>
    <v-snackbar v-model="isFailedChangePostIndex"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить данные пост отделения
    </v-snackbar>
  </v-row>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import {APP_POSTINDEX_CREATE_FAILED, APP_POSTINDEX_CREATED} from "@/events/app";
import {required} from "vuelidate/lib/validators"
import _ from "underscore";
import {AllowPostIndexSettings} from "@/enums/permission";
import PostIndexService from "@/services/post.index.service"
import CreatePostIndex from "@/components/CreatePostIndex";
import Mapper from "@/mappers"
import $store from "@/store";

export default {
  name: "PostIndexSettingsView",
  components: {
    CreatePostIndex
  },
  data() {
    return {
      account: null,
      rootSearch: "",
      createPostIndexDialog: false,

      selectedPostIndexWithChilds: null,
      rootPostIndexes: [],


      // change post index
      // isActive: true,
      isSuccessPostIndexChanged: false,
      isFailedChangePostIndex: false,

      isSuccessPostIndexCreated: false,
      isPostIndexCreatedFailed: false,

      moveForm: {
        parent: null
      },
      moveDialog: false,
      unsetDialog: false
    }
  },
  validations: {
    moveForm: {
      parent: {
        required
      }
    }
  },
  computed: {
    isAllowPostIndexSettings() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPostIndexSettings
      })
    },
    headers() {
      return [
        {
          text: "Пост-код",
          sortable: false,
          value: "post"
        }
      ]
    },
    allowSelectedPostIndexMove() {
      return this.selectedPostIndexWithChilds && this.selectedPostIndexWithChilds.childs.length === 0
    },
    rootPostIndexesWithOutSelected() {
      if (this.selectedPostIndexWithChilds)
        return _.filter(this.rootPostIndexes, rpi => {
          return rpi.id !== this.selectedPostIndexWithChilds.id
        })

      return []
    },
    moveFormParentErrors() {
      const errors = []
      if (this.$v.moveForm.$invalid && this.$v.moveForm.$dirty)
        !this.$v.moveForm.parent.required && errors.push(`Выберите родительское отделение`)

      return errors
    },
    isActive: {
      // getter
      get: function () {
        if (this.selectedPostIndexWithChilds) {
          return this.selectedPostIndexWithChilds.isActive
        }

        return false
      },
      // setter
      set: function (newValue) {
        this.selectedPostIndexWithChilds.isActive = newValue
      }
    },
    postCode: {
      // getter
      get: function () {
        if (this.selectedPostIndexWithChilds) {
          return this.selectedPostIndexWithChilds.postCode
        }

        return false
      },
      // setter
      set: function (newValue) {
        this.selectedPostIndexWithChilds.postCode = newValue
      }
    },
    name: {
      // getter
      get: function () {
        if (this.selectedPostIndexWithChilds) {
          return this.selectedPostIndexWithChilds.name
        }

        return false
      },
      // setter
      set: function (newValue) {
        this.selectedPostIndexWithChilds.name = newValue
      }
    },
    postRegion: {
      // getter
      get: function () {
        if (this.selectedPostIndexWithChilds) {
          return $store.getters.appLogin.regions.filter(r => r.id == this.selectedPostIndexWithChilds.postRegionCode)[0];
        }

        return false
      },
      // setter
      set: function (newValue) {
        this.selectedPostIndexWithChilds.postRegion = newValue
        this.selectedPostIndexWithChilds.postRegionCode = newValue.id
      }
    },
    postArea: {
      // getter
      get: function () {
        if (this.selectedPostIndexWithChilds) {
          return $store.getters.appLogin.areas.filter(a => a.id == this.selectedPostIndexWithChilds.postDistrictCode && a.region.id == this.selectedPostIndexWithChilds.postRegionCode)[0];
        }

        return false
      },
      // setter
      set: function (newValue) {
        this.selectedPostIndexWithChilds.postArea = newValue
        this.selectedPostIndexWithChilds.postDistrictCode = newValue.id
      }
    }
  },
  methods: {
    onCreatePostIndexCanceled() {
      this.createPostIndexDialog = false
    },

    onPostIndexCreated() {
      this.$refs.createPostIndex.clear()
      this.createPostIndexDialog = false
      this.isSuccessPostIndexCreated = true

      this.loadPostIndexes()
    },
    onPostIndexCreateFailed() {
      this.isPostIndexCreatedFailed = true
    },
    loadPostIndexes() {
      this.$store.dispatch(LAYOUT_LOADING_START)

      PostIndexService.getAll({root: true})
          .then(response => {
            this.rootPostIndexes = _.map(response.data, Mapper.mapPostIndex)
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadWithChilds(id) {
      this.$store.dispatch(LAYOUT_LOADING_START)

      PostIndexService.getWithChilds(id)
          .then(response => {
            this.selectedPostIndexWithChilds = Mapper.mapPostIndexWithChilds(response.data)
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },

    setActive() {
      if (this.selectedPostIndexWithChilds) {
        this.selectedPostIndexWithChilds.isActive = this.isActive
      }
    },
    setPostCode() {
      if (this.selectedPostIndexWithChilds) {
        this.selectedPostIndexWithChilds.postCode = this.postCode
      }
    },
    setName() {
      if (this.selectedPostIndexWithChilds) {
        this.selectedPostIndexWithChilds.name = this.name
      }
    },
    setRegion() {
      if (this.selectedPostIndexWithChilds) {
        this.selectedPostIndexWithChilds.postRegionCode = this.postRegion.id
        this.selectedPostIndexWithChilds.postRegion = this.postRegion
      }
    },
    setArea() {
      if (this.selectedPostIndexWithChilds) {
        this.selectedPostIndexWithChilds.postDistrictCode = this.postArea.id
        this.selectedPostIndexWithChilds.postArea = this.postArea
      }
    },
    getAreas() {
      return $store.getters.appLogin.areas.filter(a => a.region.id == this.selectedPostIndexWithChilds.postRegionCode)
    },

    rootFilter(value, search, item) {
      while (search.indexOf("  ") !== -1)
        search = search.replace("  ", " ")

      if (search.length === 0)
        return true

      const parts = search.split(" ")
      const invalidPart = _.find(parts, part => {
        return item.postCode.toString().indexOf(part) === -1 && item.name.toLowerCase().indexOf(part.toLowerCase()) === -1
      })

      return typeof (invalidPart) === "undefined"
    },
    onRootPostIndexClicked(postIndex) {
      this.loadWithChilds(postIndex.id)
    },
    onStartMoveButtonClicked() {
      this.$v.moveForm.$reset()
      this.moveForm.parent = null
      this.moveDialog = true
    },
    onMoveButtonClicked() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch(LAYOUT_LOADING_START)

        PostIndexService.move({id: this.selectedPostIndexWithChilds.id, parentId: this.moveForm.parent})
            .then(() => {
              this.moveDialog = false
              this.moveForm.parent = null
              this.selectedPostIndexWithChilds = null
              this.loadPostIndexes()
            })
            .finally(() => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    },
    onChildUnsetParentButtonClicked(postIndex) {
      this.$store.dispatch(LAYOUT_LOADING_START)
      PostIndexService.move({id: postIndex.id, parentId: null})
          .then(() => {
            this.unsetDialog = false
            this.loadPostIndexes()
            this.loadWithChilds(postIndex.parent.id)
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onSaveButtonClicked() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.isSuccessPostIndexChanged = false
      this.isFailedChangePostIndex = false
      PostIndexService.update(
          {
            id: this.selectedPostIndexWithChilds.id,
            isActive: this.selectedPostIndexWithChilds.isActive,
            postCode: this.selectedPostIndexWithChilds.postCode,
            regionId: this.selectedPostIndexWithChilds.postRegionCode,
            areaId: this.selectedPostIndexWithChilds.postDistrictCode,
            name: this.selectedPostIndexWithChilds.name
          })
          .then(() => {
            this.isSuccessPostIndexChanged = true
          }, () => {
            this.isFailedChangePostIndex = true
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    this.$bus.$on(APP_POSTINDEX_CREATED, this.onPostIndexCreated)
    this.$bus.$on(APP_POSTINDEX_CREATE_FAILED, this.onPostIndexCreateFailed)
    if (this.isAllowPostIndexSettings) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Настройка пост-отделений")
      this.loadPostIndexes()
    } else
      this.$router.go(-1)
  },
  beforeDestroy() {
    this.$bus.$off(APP_POSTINDEX_CREATED, this.onPostIndexCreated)
    this.$bus.$off(APP_POSTINDEX_CREATE_FAILED, this.onPostIndexCreateFailed)
  }
}
</script>
